module.exports = __webpack_public_path__ + "img/share_wats.e07fc6fa.png";